// Generated by app/scripts/generate-fdic-config.ts from the /orsnn/fdic-gamma/client/* SSM parameters and the alias/fdic-gamma-irm-header-signing KMS public key in account 258927150368. Gitignored; do not edit -- run `make fdicConfig stage=fdic-gamma` to regenerate.
const config = {
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://sv7a8c8dsd.execute-api.us-west-2.amazonaws.com/prod/graphql',
  },
  logs: {
    REGION: 'us-west-2',
    URL: 'https://sv7a8c8dsd.execute-api.us-west-2.amazonaws.com/prod/log',
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_VrVyQ0ae6',
    APP_CLIENT_ID: '74buqdhhsmkrlfa134qlj35thf',
    IDENTITY_POOL_ID: 'us-west-2:abcb6441-6e1d-4708-8513-c426c7885025',
  },
  fileGateway: {
    REGION: 'us-west-2',
    URL: 'https://sv7a8c8dsd.execute-api.us-west-2.amazonaws.com/prod/files',
  },
  smartHeaderGateway: {
    REGION: 'us-west-2',
    URL: 'https://sv7a8c8dsd.execute-api.us-west-2.amazonaws.com/prod/smart_header_mapping',
  },
  website: {
    URL: 'https://fdic-gamma.orsnn.com',
  },
  pinpoint: {
    REGION: 'us-west-2',
    APP_ID: '80104f8f947a4a3997d5b7439a7fde55',
  },
  irm: {
    KEY_SERVICE_URL: 'https://keys.fdic-gamma.orsnn.com',
    HEADER_SIGNING_KEYS: [
      {
        kid: 'af81338095b73f65c04cf295c703b537',
        jwk: {
          kty: 'EC',
          crv: 'P-256',
          x: '6DBbttxRaG_eEd4XEqy6W0WZC7dkn9Dl2kQQqcEMjZY',
          y: '2aLW5SHBLSYfDny_fTmsSJEYlhmNoghO34pncoh59HI',
        },
      },
    ],
  },
  features: {},
} as const;

export default config;
